// TODO: (important) Finalize this file and remove eslint-disable after approval has been confirmed. Extract any remaining text from the file and add it to the appropriate i18n file or backend (?).
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

import ContentHeader from 'components/ContentHeader';
import ContestCard from 'components/ContestCard';
import RewardMenu from 'components/RewardMenu/RewardMenu';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { usePointsHandler } from 'hooks/usePointsHandler';

import Badge from 'views/BadgeView/IncentiveBadge';

import { baseAppId, storageKeys } from 'settings';

const trackShare = () => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      APIHandler.trackEvent(
        appId,
        email,
        'collateral',
        'rewards',
        `${window.location.href}/main/rewards`,
        'rewards',
      ).then(() => {});
    });
  });
};

/**
 * `RewardsView`
 *
 * @returns {JSX.Element}
 */
const RewardsView = () => {
  const [email, setEmail] = useState('');
  const [contests, setContests] = useState([]);

  // Not used here: mounting the hook starts the shared points fetch so Achievements is ready when the user opens it.
  usePointsHandler();

  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  let mobileLink = '';
  if (params.get('mobile')) {
    mobile = true;
    mobileLink = '?mobile=true';
  }
  const hasEmail = !!params.get('email');

  // TODO If ?mobile=true is in the URL, load accesstoken and set email based on URL params

  useEffect(() => {
    if (contests.length === 0) {
      StorageHandler.load(storageKeys.lang).then(async (lang) => {
        const result = await APIHandler.getContests(baseAppId, {
          currentDate: new Date().toISOString(),
          marketFilter: [{ id: lang.code.toUpperCase() }],
        });

        if (Array.isArray(result) && result.length > 0) {
          const token = await StorageHandler.load(storageKeys.accessToken);

          const data = await Promise.all(
            result.map(async (contest) => {
              const rewards = await APIHandler.getRewards(baseAppId, token, contest.start_date, contest.end_date);

              return { ...contest, entriesCount: Array.isArray(rewards.response) ? rewards.response.length : 0 };
            }),
          );

          setContests(data);
        }
      });
    }
  }, [contests, setContests]);

  // Track share event
  useEffect(() => {
    trackShare();
  }, []);

  // ?email= is set: original behaviour.
  useEffect(() => {
    if (!hasEmail) return;
    document.body.classList.remove('no-scroll');
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        setEmail((prev) => (res.email !== prev ? res.email : prev));
      }
    });
    if (mobile) {
      // Save token and email from URL params
      const token = params.get('token');

      // If there is no token in the url, check the validity of the token currently stored.
      if (!token) {
        const expiredStoredToken = StorageHandler.isExpired(storageKeys.accessToken);
        if (expiredStoredToken) {
          window.location.href = '/main/logout';
        }
        return;
      }

      const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
      const now = new Date();
      const expires = new Date(now.getTime() + thirtyDaysInMilliseconds);

      const user = {
        email: params.get('email'),
        expires: expires.getTime(),
      };

      StorageHandler.save(storageKeys.user, user);
      StorageHandler.save(storageKeys.accessToken, token);

      setEmail(params.get('email') || '');
    }
  }, [email, setEmail, mobile, params, hasEmail]);

  // No ?email=: run once on mount. `params` is recreated every render, so the effect above would re-run after every
  // render and loop forever toggling email between '' and null.
  useEffect(() => {
    if (hasEmail) return;
    document.body.classList.remove('no-scroll');
    if (mobile) {
      // Save token and email from URL params
      const token = params.get('token');

      // If there is no token in the url, check the validity of the token currently stored.
      if (!token) {
        const expiredStoredToken = StorageHandler.isExpired(storageKeys.accessToken);
        if (expiredStoredToken) {
          window.location.href = '/main/logout';
        }
        return;
      }

      const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
      const now = new Date();
      const expires = new Date(now.getTime() + thirtyDaysInMilliseconds);

      const user = {
        email: params.get('email'),
        expires: expires.getTime(),
      };

      StorageHandler.save(storageKeys.user, user);
      StorageHandler.save(storageKeys.accessToken, token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="contentContainer rewardsView">
      <RewardMenu />

      <div className="bodyRewards">
        <div className="holder">
          <ContentHeader header={i18n.translate('rewards.title')} subtitle={i18n.translate('rewards.subheader')} />
          <hr />

          <div className="contest">
            {contests.length < 2 && <h1 className="center">{i18n.translate('rewards.home.currentContest')}</h1>}
            {contests.length >= 2 && <h1 className="center">{i18n.translate('rewards.home.currentContests')}</h1>}
            <div className="entries">
              {contests.map(({ id, title, description, terms_url: terms, image, micro_app_id: microAppId, url }) => (
                <div>
                  <Badge badgeImg={image} title={title} rounded lockLinkUrl={url} microAppId={microAppId} />
                  <ContestCard key={id} title={title} description={description} terms={terms} image={image} />
                </div>
              ))}
              {contests.length === 0 && (
                <div>
                  <p className="noContests">{i18n.translate('rewards.home.noContests')}</p>
                </div>
              )}
            </div>
          </div>
          <hr />

          <Link to={`/main/rewards/achievements${mobileLink}`} className="linkRewards">
            <ContentHeader
              icon="bars"
              header={i18n.translate('rewards.home.trainingAchievements')}
              subtitle={i18n.translate('rewards.home.trainingAchievementsText')}
              layout="row"
            />
          </Link>
          <hr />

          <Link to={`/main/rewards/dashboard${mobileLink}`} className="linkRewards">
            <ContentHeader
              icon={['far', 'badge']}
              header={i18n.translate('rewards.home.bookingContests')}
              subtitle={i18n.translate('rewards.home.bookingContestsText')}
              layout="row"
            />
          </Link>

          <hr />

          <Link to={`/main/rewards/form${mobileLink}`} className="linkRewards">
            <ContentHeader
              icon="upload"
              header={i18n.translate('rewards.home.submitBooking')}
              subtitle={i18n.translate('rewards.home.submitBookingText')}
              layout="row"
            />
          </Link>

          <hr />
        </div>
      </div>

      {mobile && (
        <style>
          {'\
    .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; } '}
          {'.thankYouView__wrapper { margin-top: 5rem !important; }'}
        </style>
      )}
    </div>
  );
};

export default RewardsView;
